
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productsList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}},{"kind":"Argument","name":{"kind":"Name","value":"rate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rate"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shop_data_source"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_generic_element_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_generic_info"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_weight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_promotions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shop_id_shop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_description_short"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_make"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stars"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shop_full_name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":476}};
    doc.loc.source = {"body":"query ProductsList( $search: String, $domain: String, $rate: Int) {\n  productsList(search: $search, domain: $domain, rate: $rate) {\n    shop_name\n    shop_data_source\n    product_generic_element_id\n    product_generic_info\n    product_weight\n    product_promotions\n    shop_id_shop\n    product_reference\n    product_description\n    product_description_short\n    product_url\n    product_make\n    product_name\n    product_price\n    stock_count\n    stars\n    shop_full_name\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductsList"] = oneQuery(doc, "ProductsList");
        
